// extracted by mini-css-extract-plugin
export default {"link":"ZNpSdw","subMenuItem":"eisYDo","title":"D0h4Lt","description":"dr3n3E"};